import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Profesorado Resuelto después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un mail en tu casilla con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.'
}, {
  q: '¿Sirve para estudiantes de primer año o solo para los avanzados?',
  a: 'Sirve para todos los años de la carrera. El Tomo 1 está diseñado especialmente para el ingreso y los primeros cuatrimestres. Los tomos 2 al 6 acompañan toda la carrera hasta las prácticas docentes.'
}, {
  q: '¿Es editable? ¿Puedo modificar las plantillas?',
  a: 'Los tomos son PDFs de lectura y estudio. Las plantillas y recursos imprimibles están diseñados para completar a mano o en digital según el recurso.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin ningún costo adicional.'
}, {
  q: '¿Sirve si estudio en una universidad o solo para institutos?',
  a: 'Sirve para ambos. El contenido está basado en los núcleos comunes de los profesorados de EF de Argentina y aplica a UNAHUR, UNLaM, ISEF y la mayoría de los institutos y universidades del país.'
}, {
  q: '¿Sirve si tengo materias de distintos años al mismo tiempo?',
  a: 'Sí. El kit está organizado por temas y no por año de cursada, por lo que podés usar el tomo que necesitás en cualquier momento de la carrera.'
}, {
  q: '¿Qué diferencia tiene con los apuntes de mis compañeros?',
  a: 'Los apuntes de tus compañeros dependen de lo que el docente dictó ese año y de cómo lo anotaron. Este kit tiene el contenido completo, organizado, con ejemplos prácticos, simulacros reales y recursos listos para usar desde el primer día.'
}, {
  q: '¿Por qué elegir el Kit Completo Élite y no el estándar?',
  a: 'El Kit Completo Élite agrega las guías visuales de las 5 materias más difíciles de la carrera y el banco completo de recursos imprimibles para tus prácticas docentes. Si querés tener absolutamente todo resuelto de una sola vez es la opción más inteligente.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si no es lo que esperabas te devolvemos el 100% del dinero sin preguntas ni formularios.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-16 bg-white" data-id="element-126">
      <div className="max-w-3xl mx-auto px-4" data-id="element-127">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-brand-950 mb-8 md:mb-12" data-id="element-128">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-3 md:space-y-4" data-id="element-129">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="border border-gray-200 rounded-xl overflow-hidden bg-gray-50" data-id="element-130">
                <button className="w-full px-4 py-4 md:px-6 md:py-5 text-left flex items-center justify-between focus:outline-none bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(isOpen ? null : index)} data-id="element-131">
                  <span className="font-bold text-gray-900 pr-4 md:pr-8 text-sm md:text-base" data-id="element-132">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-4 h-4 md:w-5 md:h-5 text-brand-500 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-133" />
                </button>
                <AnimatePresence data-id="element-134">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-135">
                      <div className="px-4 pb-4 pt-1 md:px-6 md:pb-5 md:pt-2 text-gray-600 leading-relaxed border-t border-gray-100 text-xs md:text-base" data-id="element-136">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}